// extracted by mini-css-extract-plugin
module.exports = {"lazyLoader":"jb","hidden":"kb","preventTransition":"lb","divBgImg":"mb","loaded":"nb"};